<template>
  <div :class="wrapperClasses">
    <div class="listing">
      <b-table :data="categoryData" :row-class="(row, index) => assignRowClasses(row, index)">
        <template slot-scope="props">
          <b-table-column class="subject" field="subject" label="Message type">{{props.row.label}}</b-table-column>
          <b-table-column
            class="artists numeric"
            field="artists"
            label="Artists affected"
          >{{props.row.total}}</b-table-column>
          <b-table-column class="artists numeric" field="artists" label="Artists mailed">
            <span v-if="props.row.hasMessage">{{props.row.mailed}}</span>
          </b-table-column>
          <b-table-column class="edit-column send" field="send" label="Send mails">

            <span
              v-if="props.row.hasMessage"
              class="trigger send-mails"
              :class="sendClasses(props.row)"
            >
              {{props.row.unsent}}
              <b-icon icon="email-send-outline" class="test-mail-trigger" size="is-small" @click.native="handleTestMails(props.row)" title="Preview emails" />
              <b-icon icon="send-outline" size="is-small" @click.native="handleSendMails(props.row)" 
              title="Send emails" />
            </span>
          </b-table-column>
        </template>
      </b-table>
      <div
        class="controls right-aligned"
        :class="emailListClasses"
        @click.prevent.stop="toggleShowMailList"
      >
        <span class="text">Show paid users and mails sent</span>
        <b-icon icon="view-list" size="is-medium" />
        <b-icon icon="email-send-outline" size="is-medium" />
      </div>
      <b-field class="search-controls" d>
        <b-select placeholder="Message" v-if="hasMessages" v-model="messageFilter">
          <option v-for="opt in messages" :value="opt.key" :key="opt.key">{{ opt.key|toLabel }}</option>
        </b-select>
        <b-select placeholder="Status" v-model="status">
          <option v-for="opt in categoryOpts" :value="opt.key" :key="opt.key">{{ opt.label }}</option>
        </b-select>
        <div class="total" @click="reload" title="Click to reload">{{ totalLabel }}</div>
        <input
          v-model="search"
          size="60"
          placeholder="Search"
          v-on:keyup.enter="applyFilter"
          class="search"
        />
      </b-field>
      <b-table
        v-if="showMailList"
        :data="rows"
        :row-class="(row, index) => assignRowClasses(row, index)"
      >
        <template slot-scope="props">
          <b-table-column class="fullname" field="fullname" label="Name">{{props.row.fullName}}</b-table-column>
          <b-table-column class="email" field="email" label="Email">
            <a :href="props.row.email|mailto">{{props.row.email}}</a>
          </b-table-column>
          <b-table-column field="works" label="Works">{{props.row.numWorks}}</b-table-column>
          <b-table-column field="emails" label="Mails">
            <ol v-if="props.row.hasMail">
              <li v-for="mail in props.row.mails" :key="mail.keyId">
                <span class="type">{{mail.name}}</span>
                <span class="type">{{mail.datetime|shortDatetime}}</span>
              </li>
            </ol>
          </b-table-column>
          <b-table-column class="eligible" field="ineligible" label="Eligible">
            <b-icon :icon="!props.row.ineligible|yesNoIcon" />
          </b-table-column>
          <b-table-column class="key" field="key" label="Progress">
            <progress-row :submission="props.row" />
          </b-table-column>
        </template>
      </b-table>
      <div class="message-view" v-if="hasEmailAddresses">
        <h4>Message body</h4>
        <div v-if="hasMailBody" class="mail-message body" v-html="mailMessage">         
        </div>
        <h4>Addresses</h4>
        <ul>
          <li v-for="(emailAddress, emi) in emails" :key="[emailAddress, emi].join('-')">{{emailAddress}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getMailList, getMessages, bulkMail } from "../api/methods";
import { mailingCategories } from "../api/mailing-categories";
import filters from "../mixins/filters";
import { bus } from "../main";
import ProgressRow from "./ProgressRow";
import { notEmptyString } from "../api/helpers";

export default {
  name: "MailingList",
  components: {
    ProgressRow
  },
  mixins: [filters],
  data() {
    return {
      sourceList: [],
      rows: [],
      numMails: 0,
      messageFilter: "all",
      search: "",
      status: "all",
      categories: mailingCategories,
      filter: "",
      messages: [],
      hasMessages: false,
      startIndex: 0,
      showMailList: false,
      emails: [],
      mailMessage: ''
    };
  },
  computed: {
    ...mapGetters(["settings", "options", "user"]),
    wrapperClasses() {
      let cls = ["mail"];
      return cls;
    },
    totalLabel() {
      return [
        this.numMails + " mails sent",
        this.rows.length + " artists"
      ].join(" / ");
    },
    categoryData() {
      return this.categories.map(c => {
        if (c.mailKey) {
          if (c.mailKey.length > 3) {
            this.calcCategoryTotals(c, c.mailKey);
          }
        }
        return c;
      });
    },
    categoryDataOut() {
      return JSON.stringify(this.categoryData);
    },
    categoryOpts() {
      const opts = [{ key: "", label: "All"}, ...this.categories];
      if (notEmptyString(this.messageFilter, 3)) {
        opts.splice(1,0, {key: "notSent", label: "Emails not sent"})
      }
      return opts;
    },
    emailListClasses() {
      let cls = ["show-mail-list"];
      if (this.showMailList) {
        cls.push("active");
      }
      return cls;
    },
    hasEmailAddresses() {
      return this.emails.length > 0;
    },
    hasMailBody() {
      return this.mailMessage.length > 0;
    },
  },
  mounted() {
    this.loadOverview();
    bus.$on("refresh", () => {
      const { path } = this.$route;
      if (path.indexOf("mail-list") >= 0) {
        this.loadOverview(true);
      }
    });
  },
  watch: {
    messageFilter(cv, pv) {
      if (cv !== pv) {
        this.resortList();
        this.search = "";
        this.showMailList = true;
      }
    },
    status(cv, pv) {
      if (cv !== pv) {
        this.resortList();
        this.search = "";
        this.showMailList = true;
      }
    },
    search(cv, pv) {
      if (cv !== pv) {
        if (notEmptyString(pv, 2)) {
          this.messageFilter = "all";
          this.status = "all";
        }
        this.showMailList = true;
        this.resortList();
      }
    }
  },
  methods: {
    loadOverview(refresh = false) {
      const cKey = "users-mails";
      let fetchNew = true;
      if (refresh !== true) {
        const cachedData = this.$ls.get(cKey);
        if (cachedData instanceof Object) {
          if (cachedData.valid) {
            this.assignData(cachedData);
            fetchNew = false;
          }
        }
      }
      if (fetchNew) {
        getMailList().then(data => {
          if (data.valid) {
            this.assignData(data);
            this.$ls.set(cKey, data, 5 * 60 * 1000);
          }
        });
      }
    },
    assignData(data) {
      this.numMails = data.numMails;
      this.sourceList = data.recipients;
      this.resortList();
      if (this.messages.length < 1) {
        this.loadMessages();
      }
    },
    reload() {
      this.showMailList = true;
      this.loadOverview(true);
    },
    calcCategoryTotals(category, key) {
      if (category instanceof Object) {
        category.hasMessage = false;
        const mailKey = key.split('--').shift();
        let mailKey2 = mailKey;
        switch (mailKey) {
          case "not_selected":
            mailKey2 = "unsuccessful_selected";
            break;
        }
        if (category.filterFunc) {
          const users = this.sourceList.filter(category.filterFunc);
          category.total = users.length;
          category.mailed = users.filter(
            s => s.mails.filter(m => m.key.trim() === mailKey || m.key.trim() === mailKey2).length > 0
          ).length;
          category.unsent = category.total - category.mailed;
          category.hasMessage = true;
        }
      }
    },
    matchStatusType(r, status = "") {
      switch (status) {
        case "all":
          return true;
        case "notSent":
          return this.matchStatusType(r, this.messageFilter) && r.mails.some(m => m.key === this.messageFilter) === false;
        case "detailsNotPaid":
          return !r.submitted && !r.feePaid;
        case "paidNotSubmitted":
          return !r.submitted && r.feePaid;
        case "withMediaPaidNotSubmitted":
        case "application_submitted":
        case "application_incomplete":
          return !r.submitted &&
            r.works
              .map(w => w.numMediaItems)
              .reduce((a, b) => a + b, 0) > 0;
        case "notShortlisted":
        case "not_shortlisted":
          return !r.shortlisted && r.submitted;
        case "shortlisted":
          return r.shortlisted && r.submitted;
        case "notSelected":
        case "not_selected":
        case "unsuccessful_selected":
          return r.shortlisted && !r.hasSelectedWork;
        case "selected":
          return r.shortlisted && r.hasSelectedWork;
      }
    },
    resortList() {
      const wordPattern = this.search
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9_-]/g, ".*?");
      const rgx1 = new RegExp("^" + wordPattern, "i");
      const rgx2 = new RegExp("\\b" + wordPattern, "i");
      this.rows = this.sourceList
        .filter(r => {
          if (
            notEmptyString(this.messageFilter, 5) ||
            notEmptyString(this.status, 4)
          ) {
            let valid = true;
            const sentMode = this.status !== "notSent";
            if (notEmptyString(this.messageFilter, 5)) {
              valid = r.mails.some(m => m.key === this.messageFilter) === sentMode;
            }
            if (notEmptyString(this.status, 4) && valid) {
              const matchType = sentMode? this.status : this.messageFilter;
              valid = this.matchStatusType(r, matchType);
            }
            return valid;
          } else if (notEmptyString(this.search, 2)) {
            return (
              rgx1.test(r.user.identifier) ||
              rgx2.test(r.user.firstName) ||
              rgx2.test(r.user.lastName)
            );
          }
          return true;
        })
        .map(r => {
          const { uid, identifier, firstName, lastName } = r.user;
          const fullName = [firstName, lastName].join(" ");
          const mails = r.mails.map((m, mi) => {
            m.name = m.key.replace(/_/g, " ");
            m.keyId = ["mail", uid, mi].join("-");
            return m;
          });
          const works = r.works instanceof Array ? r.works : [];
          return {
            fullName,
            email: identifier,
            uid,
            hasMail: mails.length > 0,
            mails: mails,
            numWorks: works.length,
            works,
            feePaid: r.feePaid,
            submitted: r.submitted,
            ineligible: r.ineligible,
            shortlisted: r.shortlisted,
            hasSelectedWork: r.hasSelectedWork
          };
        });
    },
    loadMessages() {
      getMessages().then(data => {
        if (data.items instanceof Array) {
          const rgx = /\b(bloomberg:?\s*)?(new\s*contemporaries:?\s*)?/gi;
          this.messages = data.items.map(m => {
            return {
              key: m.key,
              label: m.subject.replace(rgx, "")
            };
          });
          this.hasMessages = this.messages.length > 1;
          if (this.hasMessages) {
            this.messages.unshift({ key: "all", label: "All" });
          }
        }
      });
    },
    handleSendMails(category, mailMode = "run") {
      const {unsent, label} = category;
      this.$buefy.dialog.confirm({
        title: "Send bulk emails",
        message: `Are you sure you wish to email <em>${
          unsent
        }</em> people (${label})?`,
        confirmText: "Send now",
        type: "is-success",
        onConfirm: () => {
          this.sendMails(category, mailMode);
        },
      });
    },
    handleTestMails(category = '') {
      this.sendMails(category, 'skip');
    },
    sendMails(category, mailMode) {
      if (this.user) {
        this.emails = [];
        this.mailMessage = '';
        const { _id } = this.user;
        if (category instanceof Object) {
          if (!mailMode) {
            mailMode = "run";
          }
          category.sending = true;
          bulkMail(category.mailKey, _id, mailMode).then(data => {
            if (data instanceof Object) {
              setTimeout(() => {
                category.sending = false;
                if (data.valid) {
                  const { unsent } = category;
                  const { skip } = data;
                  const message = skip ? `${unsent} emails could be sent.` : `${unsent} emails have been submitted. The total sent will soon be updated`;
                  this.loadOverview(true);
                  this.$buefy.toast.open({
                    duration: 3000,
                    message,
                    position: "is-bottom",
                    type: "is-success"
                  });
                  this.mailMessage = data.message;
                  this.emails = data.emails;
                }
              }, 1000);
            }
          });
        }
      }
    },
    assignRowClasses(row, index) {
      let cls = [];
      if (index % 2 === 0) {
        cls.push("even");
      }
      return cls.join(" ");
    },
    toggleShowMailList() {
      this.showMailList = !this.showMailList;
    },
    sendClasses(category) {
      let cls = [];
      if (category.sending) {
        cls.push("sending");
      }
      return cls;
    }
  }
};
</script>
